import { MutableValue } from "@/modules/api/mutable-value.interface";

export default class FactoryRushCapacityType implements MutableValue {
  public isNew = true;

  private fCreatedAt?: Date;

  constructor(private fId: string, private fCode: string) {
    [fId, fCode].forEach((arg, index) => {
      if (arg === undefined) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get id(): string {
    return this.fId;
  }

  get code(): string {
    return this.fCode;
  }

  get displayName(): string {
    return this.fCode
      .split("_")
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(" ");
  }

  get createdAt(): Date | undefined {
    return this.fCreatedAt;
  }
}
